export default __webpack_public_path__ + "static/media/SalesforceLogo.5e3f9eee.png";